import script from "./RichMenuRegistration.vue?vue&type=script&lang=ts&setup=true"
export * from "./RichMenuRegistration.vue?vue&type=script&lang=ts&setup=true"

import "./RichMenuRegistration.vue?vue&type=style&index=0&id=4efb0f52&lang=scss&scoped=true"

import exportComponent from "/home/crmfront/lineCRM-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4efb0f52"]])

export default __exports__